import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import Button from '../Button/Button';

// eslint-disable-next-line react/prop-types
const VisuallyHidden = ({ active, children }) => <div className={cl('tab__content', { active })}>{children}</div>;

export default class Tab extends Component {
    constructor(props) {
        super(props);
        const { defaultSelect } = props;
        this.state = { selected: defaultSelect };
    }

    onSelect(title) {
        const { selectCb } = this.props;
        if (selectCb) {
            selectCb(title);
        }
        this.setState({ selected: title });
    }

    isActive(tabTitle, tabIndex) {
        const { selected } = this.state;
        return (selected && selected === tabTitle) || (!selected && tabIndex === 0);
    }

    renderContent(childrenOfTab) {
        return Children.toArray(childrenOfTab).map((childTab, index) => {
            const { title, children } = childTab.props;
            return (
                <VisuallyHidden key={`content_${title}`} active={this.isActive(title, index)}>
                    {children}
                </VisuallyHidden>
            );
        });
    }

    renderHeader(childrenOfTab) {
        return Children.toArray(childrenOfTab).map((childTab, index) => {
            const { title, icon, iconSize, className, disabled } = childTab.props;
            const { type, testId } = this.props;
            const btnType = !type || undefined ? 'tab' : `tab--${type}`;
            return (
                <li key={`header_${title}`}>
                    <Button
                        onClick={() => !disabled && this.onSelect(title)}
                        active={this.isActive(title, index)}
                        type={btnType}
                        className={cl(className)}
                        label={title}
                        icon={icon}
                        iconSize={iconSize}
                        testId={`${testId}-header-button`}
                        disabled={disabled}
                    />
                </li>
            );
        });
    }

    renderActions(childrenOfTab) {
        const { actions } = this.props;
        const activeChildTab = Children.toArray(childrenOfTab).find((childTab, index) => {
            const { title } = childTab.props;
            return this.isActive(title, index);
        });
        if (!activeChildTab) {
            return null;
        }
        const { title } = activeChildTab.props;
        const actionsItems = actions.filter((item) => item.title === title);
        const actionsList = actionsItems.map((item) => {
            const { label, callback, className, ...rest } = item;
            return (
                <Button
                    key={`${title}_${label}`}
                    onClick={callback}
                    type="tab--action"
                    className={cl(className)}
                    label={label}
                    {...rest}
                />
            );
        });
        return <>{actionsList}</>;
    }

    render() {
        const { children, type, separator, testId } = this.props;
        const classes = cl('tab', `tab--${type}`);
        return (
            <div className={classes} data-testid={testId}>
                <div className={cl('tab__header', { 'tab__header--separator': separator })}>
                    <ul className="tab__header__buttons">{this.renderHeader(children)}</ul>
                    <div>{this.renderActions(children)}</div>
                </div>
                {this.renderContent(children)}
            </div>
        );
    }
}

Tab.defaultProps = {
    testId: 'tab',
    actions: [],
    type: undefined,
    selectCb: null,
    defaultSelect: null,
    icon: null,
    iconSize: null,
    separator: false,
};

Tab.propTypes = {
    selectCb: PropTypes.func,
    defaultSelect: PropTypes.string,
    testId: PropTypes.string,
    children: PropTypes.node.isRequired,
    actions: PropTypes.array,
    type: PropTypes.oneOf(['pills', undefined]),
    separator: PropTypes.bool,
    icon: PropTypes.string,
    iconSize: PropTypes.number,
};
